import { useCallback, useEffect, useState } from "react";
import camelcase from "camel-case";
import i18n from "src/i18n";

import sdk from "src/sdk";

export const handleCurrentState = async (
  data,
  { forgotFlowState, setForgotFlowState }
) => {
  switch (forgotFlowState.state) {
    case "entry": {
      try {
        const result = await sdk.resetChallengeQuestions(data);

        const {
          data: { state, availableChannels },
          links,
        } = result;

        setForgotFlowState({
          state: camelcase(state),
          availableChannels,
          links,
        });
      } catch (e) {
        if (e && e.status === 401) {
          throw new Error(
            i18n.t("olb.login.resetChallenges.entryError", {
              defaultValue:
                "The information you submitted appears to be incorrect. Please try again or contact us at 800.473.2328 for additional help.",
            })
          );
        } else {
          throw e;
        }
      }

      break;
    }
    case "selectChannel": {
      const result = await sdk.selectChannelChallengeQuestionReset(
        data.userChannelId,
        {
          path: forgotFlowState.links[forgotFlowState.state],
        }
      );

      setForgotFlowState({
        ...forgotFlowState,
        state: "forgotChallengeQuestionsComplete",
      });

      break;
    }
    case "resetQuestions": {
      const result = await sdk.resetChallengeQuestionsSet(data, {
        timecode: forgotFlowState.timecode,
        uid: forgotFlowState.uid,
      });

      setForgotFlowState({
        state: "complete",
      });

      break;
    }
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/handleCurrentState.js